<main class="form-page">
  <section class="form-page__content" [attr.aria-labelledby]="title ? 'form-page-title' : null">
    @if (title) {
      <h1 id="form-page-title">{{ title }}</h1>
    }
    <ng-content />
  </section>
</main>
